import { render, staticRenderFns } from "./buttonCategory.vue?vue&type=template&id=56178d39&scoped=true&"
import script from "./buttonCategory.vue?vue&type=script&lang=js&"
export * from "./buttonCategory.vue?vue&type=script&lang=js&"
import style0 from "./buttonCategory.vue?vue&type=style&index=0&id=56178d39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56178d39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsItems})
